{
  "description": "Description",
  "parties": "Parties",
  "amount": "Amount",
  "method": "Method",
  "date": "Date",
  "debit": "Debit",
  "credit": "Credit",
  "accounted-for": "Accounted for",
  "observations": "Observations",
  "options": "Options",
  "delete": "Delete",
  "disbursements": "Disbursements",
  "receipts": "Receipts",
  "ledger": "Ledger",
  "add-entry": "Add Entry",
  "unaccounted": "Unaccounted",
  "rest": "Rest",
  "titleparty": "Delete Disbursement Party",
  "confirmationMessageParty": "Are you sure you want to delete this party associated with the disbursement entry? This action cannot be undone.",
  "titleDisbursement": "Delete Disbursement Entry",
  "confirmationMessageDisbursement": "Are you sure you want to delete this disbursement entry? This action cannot be undone.",
  "titleAccounted": "Delete Accounted Entry",
  "confirmationMessageAccounted": "Are you sure you want to delete this accounted entry associated with the disbursement entry? This action cannot be undone.",
  "createLinkEntry": "Add Entry",
  "editLinkEntry": "Edit Entry",
  "close": "Close",
  "add": "Add",
  "total": "Total",
  "already-accounted": "Accounted",
  "filter": "Filter",
  "error-missing-letter-number": "This entry must have both a letter and a number to be accounted for",
  "error-letter-j": "Letter J entries cannot be selected for accounting",
  "empty-entry": "There are no entries recorded",
  "no-entries-found": "We found no entry to account for",
  "error-max-amount": "The value cannot be greater than",
  "error-amount": "It must be a positive number",
  "required": "Required",
  "error-date": "It must be a valid date",
  "edit": "Edit",
  "netfunded": "Net Funded",
  "balance": "Balance",
  "balanced": "Balanced",
  "disburse": "To disburse",
  "underfunded": "Underfunded",
  "posted": "Posted",
  "true": "True",
  "false": "False",
  "titlePosted": "Change Posted Status ",
  "confirmationMessagePosted": "Are you sure you want to change the status of this entry? This action will update the posted value",
  "agree": "Agree",
  "amount_override": "Amount Override",
  "proceeds": "Proceeds",
  "filter-field-description": "Description",
  "filter-field-name": "Name",
  "filter-field-role": "Role",
  "filter-field-disabled": "Filter disabled, showing all entries",
  "filter-helper-text": "Use filter below to look for:",
  "createLinkEntry-disbursement": "Add Disbursement",
  "createLinkEntry-receipt": "Add Receipt",
  "createLinkEntry-netfunded": "Add Net Funded Entry"
}
